<template>
  <div class="recharge-continner container">
    <div class="header-title">
      <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"
        ><van-icon name="revoke"></van-icon
      ></span>
      <div>充值中心</div>
    </div>
    <div class="continner">
      <div class="sub-continner" style="margin-top: 4.2rem;">
        <div class="main-card" style="margin: 1rem 0.5rem;">
          <div class="main-card-content">
            <div class="recharge-title">
              支付你的订单
              <div
                style="display: inline-flex;flex-direction: row;line-height: 33px;"
              >
                <span>剩余时间</span><van-count-down :time="time" />
              </div>
            </div>
            <div class="recharge-subtitle">
              请在30分钟内向下面的地址转入您需要充值的USDT数量。<span
                >请务必与订单金额一致（例：转100USDT则填700元，比例为1:7）</span
              >
            </div>
          </div>
        </div>

        <div
          style="height: 55dvh; overflow-x:hidden;overflow-y:scroll;display: flex;flex-direction: column; justify-content: center;align-items: center;"
        >
          <div style="height: 100%;width: 100%;">
            <div class="qrcode-continner" :style="qrStyle">
              <div id="qrcode">
                <qrcode
                  :text="rechargeInfo.backCardNum"
                  :options="{
                    margin: 2,
                    width: 50,
                    color: { dark: '#000000', light: '#FFFFFF' },
                  }"
                ></qrcode>
              </div>
            </div>
            <div style="margin: 12px;font-size: 14px;">
              <!-- 建议使用TRC20网络用钱包扫码充值！交易所容易风控。充值地址自动更换，后台增加地
              址。二维码根据地址变化自动变化。 -->
              {{ shareTips }}
            </div>
            <div class="invitmoney-continner">
              充值金额
              <br />
              <input
                v-model="rechargeInfo.payMoney"
                type="number"
                placeholder="1"
                class="money-input"
                style="width: 100%;"
              />
            </div>
            <div class="invitmoney-continner">
              充值地址
              <br />
              <div class="recharge-addr-row">
                <input
                  ref="addrInput"
                  v-model="rechargeInfo.backCardNum"
                  type="text"
                  disabled
                  class="money-input recharge-addr-input"
                  :style="{ fontSize: addrFontSize + 'px !important' }"
                />
                <button
                  class="recharge-addr-copy"
                  v-clipboard:copy="rechargeInfo.backCardNum"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  点击复制
                </button>
              </div>
            </div>
            <van-button
              round
              type="info"
              @click="commitRecharge"
              :disabled="isClicked"
              style="line-height: 1.7;"
              >提交</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.recharge-continner {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}
.continner {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 90%;
  .recharge-subtitle {
    color: rgb(133, 127, 127);
    font-size: 12px;
    span {
      color: red;
      font-size: 12px;
    }
  }

  button {
    width: 100%;
    margin-top: 10px;
  }

  .qrcode-continner {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px 0 6px;

    #qrcode {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px; /* 白色静区：既保证扫码识别，也保证视觉留白 */
      background-color: #fff; /* 二维码卡片白底 */
      border: 1px solid rgb(218, 214, 214);
      border-radius: 14px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    /* 二维码显示尺寸由 JS 计算后经 --qr-size 写入（见 fitQrSize）。
       同时命中 img 和 canvas：部分内核渲染 QR 用的元素不一样，漏掉其中一个
       就会造成“电脑变了、手机不变”。var() 的兜底保证 JS 未跑时也有合理尺寸。 */
    ::v-deep img,
    ::v-deep canvas {
      display: block;
      width: var(--qr-size, 160px);
      height: var(--qr-size, 160px);
    }
  }

  .invitmoney-continner {
    color: rgb(181, 180, 180);
    font-size: 14px;
    width: calc(100% - 24px);
    margin: 12px;
    box-sizing: border-box;
  }

  .recharge-addr-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
  }

  /* 充值金额 / 充值地址 输入框共用同一套几何样式，保证高度一致 */
  .money-input {
    -webkit-appearance: none;
    appearance: none;
    box-sizing: border-box;
    height: 33px;
    min-height: 33px;
    max-height: 33px;
    line-height: 33px;
    padding: 0 5px;
    border-radius: 5px;
    background-color: transparent;
    border: 1px solid rgb(200, 200, 200);
    color: #111;
    outline: none;
  }

  .recharge-addr-input {
    flex: 1 1 0%;
    min-width: 0;
    margin-right: 8px;
  }

  .recharge-addr-input:disabled {
    color: #111;
    -webkit-text-fill-color: #111;
    opacity: 1;
    background-color: transparent;
  }

  .recharge-addr-copy {
    color: rgba(8, 12, 237, 0.811);
    background-color: transparent;
    border: 0;
    font-size: 12px;
    line-height: 33px;
    white-space: nowrap;
    flex-shrink: 0;
    width: auto;
    margin: 0;
    padding: 0 0 0 4px;
  }
}

.recharge-title {
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  padding: 10px;
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span,
  div {
    color: red;
    font-size: 12px;
    margin-left: 10px;
    line-height: 33px;
  }
  span::before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 46%;
    margin-right: 2px;
    border: 1px solid rgb(251, 65, 3);
    vertical-align: middle;
    margin-top: -4px;
    margin-right: 6px;
  }
}
</style>
<script>
import Qrcode from "vue-qrcode-component";
import { Dialog, Toast } from "vant";
import {
  queryBackCardSetting,
  addInvestMoney,
} from "../../api/system/sys_backInfo";
import { getTips } from "../../api/system/sys_config";
import { mixins } from "../../mixins/mixins";
export default {
  name: "rechargemoney",
  components: {
    Qrcode,
  },
  mixins: [mixins],
  data() {
    return {
      isClicked: false,
      rechargeInfo: {
        payMoney: "1",
        backCardNum: "sdjfskldfjsdfjdlskfjsdkl",
      },
      shareTips: "",
      addrFontSize: 16,
      qrSize: 160,
      time: 30 * 60 * 1000,
    };
  },
  computed: {
    qrStyle() {
      return { "--qr-size": (this.qrSize || 160) + "px" };
    },
  },
  mounted() {
    this.$emit("titleChange", "充值");
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();
    queryBackCardSetting().then((res) => {
      if (res.success) {
        console.log(res.data);
        this.rechargeInfo.backCardNum = res.data.backCardNum;
      }
    });

    getTips().then((res) => {
      if (res.success) {
        //console.log(res.data);
        this.shareTips = res.data.charge_text;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
    if (this._addrMirror) {
      this._addrMirror.remove();
      this._addrMirror = null;
    }
  },
  watch: {
    "rechargeInfo.backCardNum"() {
      this.fitAddrFont();
    },
  },
  methods: {
    // 窗口尺寸变化（旋转/横竖屏/分屏等）时，同时刷新地址输入框字号与二维码尺寸
    onWindowResize() {
      this.fitAddrFont();
      this.fitQrSize();
    },
    // 二维码尺寸：在 JS 里用 vmin 口径算好并写成具体 px。
    // 不走 CSS clamp()/vmin，避免鸿蒙/老内核不支持导致规则被丢弃、手机端始终不生效。
    // 想调大小就改下面三个值：比例 0.32、最小 80、最大 250。
    fitQrSize() {
      const ratio = 0.32;
      const min = 80;
      const max = 250;
      const vmin = Math.min(window.innerWidth, window.innerHeight);
      const size = Math.round(vmin * ratio);
      this.qrSize = Math.max(min, Math.min(max, size));
    },
    fitAddrFont() {
      this.$nextTick(() => {
        const el = this.$refs.addrInput;
        if (!el) return;
        const text = el.value || "";
        if (!text) {
          this.addrFontSize = 16;
          return;
        }
        const cs = window.getComputedStyle(el);
        const avail =
          el.clientWidth -
          (parseFloat(cs.paddingLeft) || 0) -
          (parseFloat(cs.paddingRight) || 0);
        if (avail <= 2) return;

        // 离屏镜像：与输入框用同一字体/字重/字距实测文本真实宽度，
        // 比 canvas 估算更贴近浏览器真实渲染，避免末尾字符仍被截断。
        let m = this._addrMirror;
        if (!m) {
          m = document.createElement("span");
          m.style.cssText =
            "position:absolute;left:-99999px;top:0;visibility:hidden;white-space:nowrap;pointer-events:none;";
          document.body.appendChild(m);
          this._addrMirror = m;
        }
        m.style.fontFamily = cs.fontFamily;
        m.style.fontWeight = cs.fontWeight;
        m.style.fontStyle = cs.fontStyle;
        m.style.letterSpacing = cs.letterSpacing;
        m.textContent = text;

        const fitsAt = (px) => {
          m.style.fontSize = px + "px";
          // 留 1px 安全余量，防止四舍五入后最后一个字符贴边/被盖
          return m.offsetWidth <= avail - 1;
        };

        let size;
        if (fitsAt(16)) {
          size = 16;
        } else {
          // 先用 100px 粗算一个接近值，再向下微调直到实测放得下
          m.style.fontSize = "100px";
          const w100 = m.offsetWidth || 1;
          size = Math.floor(((avail - 1) / w100) * 100 * 10) / 10;
          size = Math.max(8, Math.min(16, size));
          while (size > 8 && !fitsAt(size)) {
            size -= 0.5;
          }
          if (!fitsAt(size)) size = 8;
        }
        this.addrFontSize = size;
        el.scrollLeft = 0;
      });
    },
    onCopy(e) {
      //alert('复制成功！: ' + e.text)
      Toast.success("复制成功！");
    },
    onError(e) {
      Toast.fail("你的浏览器不支持复制拷贝！");
    },
    backUp() {
      this.$router.back();
    },
    commitRecharge() {
      //console.log(this.rechargeInfo)
      this.isClicked = true;
      addInvestMoney(this.rechargeInfo).then((res) => {
        if (res.success) {
          //console.log(res.data);
          Dialog.confirm({
            title: "充值结果",
            message: `充值成功， 充值金额${this.rechargeInfo.payMoney}, 等待审核！`,
          })
            .then(() => {
              this.$router.back();
              this.isClicked = false;
            })
            .catch((err) => {
              Toast.fail("充值失败：", res.message);
            });
        }
      });
    },
  },
};
</script>
